// extracted by mini-css-extract-plugin
module.exports = {"container":"IconBlock__container___otEnv","icon":"IconBlock__icon___24qop","title":"IconBlock__title___3JmvD fonts__calibre-medium___6zVIu"};